<div style="width: 100%" [nbSpinner]="this.isLoading">
  <mat-form-field style="width: 100%">
    <mat-label>Printer</mat-label>
    <mat-select (selectionChange)="this.onSelectChange()" id="select" [required]="this.isRequired" ngDefaultControl [(ngModel)]="printer" name="select" #select="ngModel"
      (ngModelChange)="onSelectChange()">
      <mat-option>
        <ngx-mat-select-search [(ngModel)]="this.searchValue" (ngModelChange)="filter()" placeholderLabel="Find printer..."
          noEntriesFoundLabel="No printer found" name="search" #search="ngModel">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngIf="this.objList.length === 0">
        Please search for a printer.
      </mat-option>
      <mat-option *ngFor="let x of this.objList" [value]="x">
        {{x.name}} ({{x.status}})
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div [hidden]="select.valid || select.pristine" class="alert alert-danger">
    Printer is required
  </div>
</div>